export enum TpaView {
  group = 'group',
  detail = 'detail'
}

export enum TpaStatusFilter {
  Active = 'active',
  Inactive = 'inactive',
  Draft = 'draft',
  All = 'all'
}
